<template>
  <AppHero />
  <MultiBusinessSection />
  <CentralizeSimplifySection />
  <NfseSection v-if="language === 'pt_BR'" />
  <FinancialManagementSection />
  <ClientsContractsSection />
  <ReportsDashboardsSection />
  <Features />
  <TagCloudSection />
  <Plans id="plans" />
  <Faq id="faq" />
  <TopBar />
  <ContactSection id="contact" />
  <AppComingSoonSection compact />
</template>

<script>
import ContactSection from '@/components/ContactSection.vue'
import Features from '@/components/Features.vue'
import TagCloudSection from '@/components/TagCloudSection.vue'
import TopBar from '@/components/TopBar.vue'
import AppHero from '@/components/AppHero.vue'
import Plans from '@/components/Plans.vue'
import MultiBusinessSection from '@/components/MultiBusinessSection.vue'
import CentralizeSimplifySection from '@/components/CentralizeSimplifySection.vue'
import NfseSection from '@/components/NfseSection.vue'
import FinancialManagementSection from '@/components/FinancialManagementSection.vue'
import ClientsContractsSection from '@/components/ClientsSection.vue'
import ReportsDashboardsSection from '@/components/ReportsDashboardsSection.vue'
import Faq from '@/components/Faq/Faq.vue'
import AppComingSoonSection from '@/components/AppComingSoonSection.vue'

import { language } from '@/plugins/i18n'

export default {
  name: 'HomeView',
  components: {
    TopBar,
    Features,
    TagCloudSection,
    AppComingSoonSection,
    AppHero,
    Plans,
    MultiBusinessSection,
    CentralizeSimplifySection,
    NfseSection,
    FinancialManagementSection,
    ClientsContractsSection,
    ReportsDashboardsSection,
    ContactSection,
    Faq,
  },

  data() {
    return {
      language,
    }
  },
}
</script>
